export const slotItemBuilder =
  ({ playerData, teamData, defaultAssetUrl }) =>
  (id, isPlaceholder) => {
    const { fullName: subText, image, teamId, number, position } = playerData[id];

    if (!teamData[teamId]) {
      return {
        id: null,
        subText: null,
        text: null,
      };
    }

    const { abbr, logo } = teamData[teamId];

    const teamAbbr = abbr && `${abbr} -`;
    const text = `${teamAbbr} #${number} - ${position}`;

    const assetUrl = (image && image) || defaultAssetUrl;
    const secondaryAssetUrl = (logo && logo) || defaultAssetUrl;

    return {
      id,
      subText,
      text,
      assetUrl: !isPlaceholder && assetUrl,
      secondaryAssetUrl: !isPlaceholder && secondaryAssetUrl,
    };
  };

/**
 * Error codes that indicate a player is unavailable for selection
 */
const PLAYER_UNAVAILABLE_ERROR_CODES = ['hc.30', 'hc.8'];

/**
 * Determines if a submission error indicates that a player is unavailable
 * True if the error indicates player unavailability based on hc.30, hc.8 error codes
 */
export const isPlayerUnavailableError = (error) => {
  if (!error?.code || typeof error.code !== 'string') {
    return false;
  }

  return PLAYER_UNAVAILABLE_ERROR_CODES.includes(error.code);
};
